import React from "react";
import styled from "styled-components";
import info from '../../assets/newSvg/info-circle.svg'

const Style = styled.div`
    display: flex;
    flex-direction: column;
    margin:5rem auto;
    justify-content: center;
    align-items: center;
    &.full{
        grid-column: 1/6 ;
    }
    .info{
        width: 4rem;
        aspect-ratio: 1;
    }
    @media screen and (max-width:850px ){
        margin: 3rem auto;
    }
`

export const NotFindContent =({text , classname})=>{
    return(
        <Style className={classname} >
            <img src={info} alt="info" className="info"/>
            <span className="text">{text}</span>
        </Style>
    )
}